import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import DefaultLayout from './layouts/Default.vue'
import DashboardLayout from './layouts/Dashboard.vue'
import DashboardRTLLayout from './layouts/DashboardRTL.vue'
import router from './router'
import api from '@/api'
import util from '@/libs/util'
import store from '@/store/index'
// import './plugins/click-away'
import './scss/app.scss';
import * as echarts from "echarts";
import permission from '@/utils/permission'

Vue.use(Antd);
Vue.use(permission)
Vue.prototype.$api = api
Vue.prototype.$util = util
Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

// Adding template layouts to the vue components.
Vue.component("layout-default", DefaultLayout);
Vue.component("layout-dashboard", DashboardLayout);
Vue.component("layout-dashboard-rtl", DashboardRTLLayout);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')